function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_556",
  "data-name": "Group 556",
  transform: "translate(1.37 1.413)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_539",
  "data-name": "Group 539",
  transform: "translate(1.229 9.857) rotate(-90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_19",
  "data-name": "Line 19",
  y2: 24.989,
  transform: "translate(4.946 0)",
  fill: "none",
  stroke: "#00123e",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_399",
  "data-name": "Path 399",
  d: "M0,0,4.953,4.616,9.857,0",
  transform: "translate(0 21.939)",
  fill: "none",
  stroke: "#00123e",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_540",
  "data-name": "Group 540",
  transform: "translate(4.616 0) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_399-2",
  "data-name": "Path 399",
  d: "M0,0,4.953,4.616,9.857,0",
  fill: "none",
  stroke: "#00123e",
  strokeLinecap: "round",
  strokeWidth: 2
})));

var SvgSwitch = function SvgSwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.525,
    height: 12.684,
    viewBox: "0 0 30.525 12.684",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/switch.7c00d8d9.svg";
export { ForwardRef as ReactComponent };